// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"src-__app-module___wrapper","header":"src-__app-module___header","appBody":"src-__app-module___appBody","appTitle":"src-__app-module___appTitle","appTitleHide":"src-__app-module___appTitleHide","legend":"src-__app-module___legend","mapText":"src-__app-module___mapText","footnote":"src-__app-module___footnote","embedInfo":"src-__app-module___embedInfo","modal":"src-__app-module___modal","modalText":"src-__app-module___modalText","embedSnippetContainer":"src-__app-module___embedSnippetContainer","closeModal":"src-__app-module___closeModal"};


//////////////////
// WEBPACK FOOTER
// ./src/app.module.css
// module id = 1805
// module chunks = 0